import "./style.css";

import { CSSProperties, memo } from "react";
import { useObservable } from "react-use-observable";

import { durationService } from "../../../../../../../services/duration";

type IDurationProps = {
  customStyles?: CSSProperties;
}

const Duration = ({ customStyles }: IDurationProps) => {
  const [videoDuration] = useObservable(
    () => durationService.getVideoDuration(),
    []
  );
  const [videoCurrentTime] = useObservable(
    () => durationService.getVideoCurrentTime(),
    []
  );

  return (
    <div style={customStyles} className="duration">
      {`${videoCurrentTime || "0:00"} / ${videoDuration || "0:00"}`}
    </div>
  );
};

export default memo(Duration);
